import { EmailRecipient, EmailRecipientKind, EmailTemplateContext } from "./template";
import { Grid } from "../../../app/core/components/grid";
import { Dialog, DialogProps } from "../../../app/core/components/dialog";
import { DropDownList } from "../../../app/core/components/dropDownList";
import { FieldInstance } from "../../core/components/field";
import { Helper } from "../../core/util/helper";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { ComponentHelper } from "../../core/util/componentHelper";
import EmailSelector, { EmailLookUp, EmailSelectorProps } from "../emailSelector";
import { BaseComponentProps } from "../../core/components/baseComponentProps";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces";
import React from "react";

export default class StaticEmails extends React.Component<StaticEmailsProps, StaticEmailsState> {
    private gridOptions: kendo.ui.GridOptions;
    private standardButtons: Array<ToolBarStandardButton>;
    private dataSource: KeyValuePair<EmailRecipientKind, string>[];
    private dialogRef: RecipientDialog;
    private gridId = kendo.guid();
    private onlyAddress = false;
    constructor(props: StaticEmailsProps) {
        super(props)
        this.state = {
            gridData: props.value
                .map(this.mapToGridItem)
                .filter(this.distinct)
                .sort(this.orderByAlphabet),
            selectedItem: null
        }
        this.onlyAddress = props.field["onlyAddress"] ?? false;
        this.initApp();
    }

    private mapToGridItem = (emailRecipient: EmailRecipient | string) => {
        switch (typeof emailRecipient) {
            case "string":
                const gridItem_s: GridItem = {
                    EmailAddress: emailRecipient,
                    Id: kendo.guid(),
                    Kind: EmailRecipientKind.Regular
                }
                return gridItem_s;
            default:
                const gridItem: GridItem = {
                    EmailAddress: emailRecipient.EmailAddress,
                    Id: kendo.guid(),
                    Kind: emailRecipient.Kind
                }
                return gridItem;
        }

        
    }

    //für array.sort
    private orderByAlphabet = (a: GridItem, b: GridItem) => {
        if (a.EmailAddress < b.EmailAddress) {
            return -1;
        }
        if (a.EmailAddress > b.EmailAddress) {
            return 1;
        }
        return 0;
    }

    //für array.filter
    private distinct = (value: GridItem, index: number, self: GridItem[]) => {
        return self.findIndex(f => f.EmailAddress.toLowerCase() === value.EmailAddress.toLowerCase()) === index;
    };

    private initApp = () => {
        this.dataSource = [
            {
                Key: EmailRecipientKind.Regular,
                Value: this.props.context.translations["WebCRM.Email.RecipientEmails"]

            },
            {
                Key: EmailRecipientKind.CarbonCopy,
                Value: this.props.context.translations["WebCRM.Email.CCEmails"]
            },
            {
                Key: EmailRecipientKind.BlindCarbonCopy,
                Value: this.props.context.translations["WebCRM.Email.BCCEmails"]
            }
        ];
        this.standardButtons = [
            {
                type: ToolBarStandardButtonType.NEW,
                caption: Config.translations.newLabel,
                enabled: true
            },
            {
                type: ToolBarStandardButtonType.DELETE,
                caption: Config.translations.deleteLabel,
                enabled: true 
            }
        ];
        this.initGridOptions();
    }

    private initGridOptions = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "EmailAddress",
                    title: this.props.context.translations["Field.Adresse.email"]
                }
                
            ]
        };

        if (!this.onlyAddress) {
            this.gridOptions.columns.push({
                field: "Kind",
                title: this.props.context.translations["Standard.Typ"],
                template: (dataItem: EmailRecipient) => {
                    return `<div id="emailDropDownWrapper"><input class="dropDownTemplate" data-id=${dataItem.Id}></div>`;
                    //return `<div>${this.dataSource.find(f => f.Key === dataItem.Kind).Value}</div>`;
                }
            });
        }
    }
    
    private renderGrid = () => {
        return (
            <div className="flex-container" id={this.gridId}>
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="staticEmails"
                    standardButtons={this.standardButtons}
                    onClickStandardButton={this.handleClickStandardButton}
                    onDataBound={this.onDataBound}
                    onSelectionChanged={this.onSelectionChange}
                />
            </div>
        );
    }

    private onSelectionChange = (item: GridItem) => {
        if (Helper.hasValue(item)) {
            this.setState({ selectedItem: item })
        }
    }

    private onDataBound = (e) => {
        const grid = e.sender;
        const items = e.sender.items();

        const dataSource = this.dataSource;
        const onValueChange = (kind: EmailRecipientKind, id: string) => {
            const gridData = this.state.gridData;
            const index = gridData.findIndex(f => f.Id === id);
            gridData[index].Kind = kind;
            this.setValue(gridData);
        }

        items.each(function () {
            const dataItem = grid.dataItem(this);
            const ddt = $(this).find('.dropDownTemplate');
            const id = ddt.attr("data-id");
            $(ddt).kendoDropDownList({
                value: dataItem.Kind.toString(),
                dataSource: dataSource,
                dataTextField: "Value",
                dataValueField: "Key",
                change: (e) => {
                    const selectedIndex = e.sender["selectedIndex"];
                    onValueChange(dataSource[selectedIndex].Key, id);
                }
            });
        });
        this.fixGridStyle();
    }


    private fixGridStyle = () => {
        const spans = document.querySelectorAll("#emailDropDownWrapper > span") as NodeListOf<HTMLSpanElement>;
        spans.forEach((el) => {
            el.style.width = "100%"
        });
    }

    private setValue = (data: GridItem[]) => {
        data = data.filter(this.distinct).sort(this.orderByAlphabet);
        this.setState({ gridData: data }, () => {
            let values = []; 
            if (this.onlyAddress) {
                values = data.map((item) => {
                    return item.EmailAddress;
                })
            } else {
                values = data.map((item) => {
                    return {
                        EmailAddress: item.EmailAddress,
                        Kind: item.Kind
                    };
                })
            }

            
            
            this.props.onChange(this.props.field, values);
        })
    }

    private onOK = (items: GridItem[]) => {
        let data = items.concat(this.state.gridData);
        this.setValue(data);
    }

    private delete = (id: string) => {
        const data = this.state.gridData.filter(f => f.Id !== id);
        this.setValue(data);
    }

    private handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: GridItem) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this.dialogRef.openNew();
                break;
            case ToolBarStandardButtonType.DELETE:
                this.delete(dataItem.Id);
                break;
        }
    }

    render() {
        const grid = Helper.hasValue(this.gridOptions) ? this.renderGrid() : null;
        return (
            <>
                {grid}
                <RecipientDialog
                    dataSource={this.dataSource}
                    onOk={this.onOK}
                    ref={(ref) => {
                        this.dialogRef = ref;
                    }}
                    translations={this.props.context.translations}
                    onlyAddress={this.onlyAddress}
                />
            </>
        );
    }
}

interface StaticEmailsProps extends BaseComponentProps {
    value: EmailRecipient[]|string[];
    onChange: (field, value: EmailRecipient[]) => void;
    context: EmailTemplateContext;
}


interface GridItem extends EmailRecipient {
    Id: string;
}
interface StaticEmailsState {
    gridData: GridItem[];
    selectedItem: GridItem;
}

class RecipientDialog extends React.Component<RecipientDialogProps, RecipientDialogState> {
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    const lst = this.state.emails.map((mail: string) => {
                        const item: GridItem = {
                            EmailAddress: mail,
                            Id: kendo.guid(),
                            Kind: this.state.kind
                        };

                        return item;
                    })
                    this.props.onOk(lst)
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false })
        },
        width: 500
    };

    constructor(props: RecipientDialogProps) {
        super(props)

        this.state = {
            dialogOpen: false,
            kind: EmailRecipientKind.Regular,
            emails: []
        }
    }

    openNew = () => {
        this.setState({ dialogOpen: true,  kind: EmailRecipientKind.Regular, emails: [] })
    }

    private renderDialog = () => {
        return (
            <div>
                <Dialog {...this.dialogProps} open={true}>
                    {this.renderEmailSelector()}
                    {this.props.onlyAddress ? null : this.renderDropDown()}
                </Dialog>
            </div>
        );
    }

    private renderDropDown = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.dataSource = this.props.dataSource;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.optionLabel = "";
        props.value = this.state.kind;
        props.onChange = (_, value: EmailRecipientKind) => {
            this.setState({ kind: value })
        }

        return (
            <FieldInstance label={this.props.translations["Standard.Typ"]} noHover={true}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private renderEmailSelector = () => {
        const props: EmailSelectorProps = {
            field: {
                tagTemplate: "#let inner = data.Name; if(data.Type != -1){inner += ' (' + data.Email + ')'}#<div>#=inner#</div>",
                itemTemplate: "<table cellspacing='0' style='table-layout:fixed; width:800px'><colgroup><col style='width: 200px;' /><col style='width: 400px' /><col style='width: 200px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.Name}</td><td style='vertical-align:top; word-break: break-all'>#if(data.Type != -1){#${data.Email}#}#</td><td style='vertical-align:top'>${data.TypeDesignation}</td></tr></table>",
                noDataTemplate: Helper.getTranslation("WebCRM.Email.TypeName"),
                searches: [],
                model: "n/a",
                type: "n/a"
            },
            value: this.state.emails.join(", "),
            context: null,
            disabled: false,
            onChange: (_, __, dataItem: EmailLookUp[]) => {
                const mails = dataItem.map((item) => { return item.Email })
                this.setState({ emails: mails })
            },
            required: false
        }


        return (
            <FieldInstance label={this.props.translations["Field.Adresse.email"]} noHover={true}>
                <EmailSelector {...props} />
            </FieldInstance>
        );
    }

    render() {
        return this.state.dialogOpen ? this.renderDialog() : <></>;
    }
}

interface RecipientDialogProps {
    dataSource: KeyValuePair<EmailRecipientKind, string>[];
    onOk: (items: GridItem[]) => void;
    translations: StringKeyDictionary<string>;
    onlyAddress: boolean;
}

interface RecipientDialogState {
    dialogOpen: boolean;
    kind: EmailRecipientKind;
    emails: string[];
}